import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DictationPage from '../components/DictationPage';
import CheckResultPage from '../components/CheckResultPage';
import { useSettings } from '../hooks/useSettings';

const Dictation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings, getDictationSettings } = useSettings();
  const [mode, setMode] = useState('dictation'); // 'dictation' 或 'check'
  const [dictationData, setDictationData] = useState({
    words: [],
    bookInfo: { grade: '三年级', term: '上册', unit: 'Unit 2' },
    results: [],
    correctCount: 0,
    totalCount: 0
  });
  
  // 从URL参数或location state中获取数据
  useEffect(() => {
    // 如果有传递的数据，则使用传递的数据
    if (location.state && location.state.words) {
      const { words, bookInfo, settings: customSettings } = location.state;
      setDictationData(prev => ({
        ...prev,
        words,
        bookInfo: bookInfo || prev.bookInfo,
        totalCount: words.length,
        // 保存自定义设置
        customSettings
      }));
    } else {
      // 否则使用示例数据
      const sampleWords = [
        { id: 1, word: 'apple' },
        { id: 2, word: 'banana' },
        { id: 3, word: 'grape' },
        { id: 4, word: 'peach' },
        { id: 5, word: 'pear' },
        { id: 6, word: 'watermelon' },
        { id: 7, word: 'coconut' },
      ];
      
      setDictationData(prev => ({
        ...prev,
        words: sampleWords,
        totalCount: sampleWords.length
      }));
    }
    
    // 从URL参数中获取模式
    const params = new URLSearchParams(location.search);
    const modeParam = params.get('mode');
    if (modeParam === 'check') {
      setMode('check');
    }
  }, [location]);
  
  // 处理听写完成
  const handleDictationComplete = (results) => {
    // 计算正确数量
    const correctCount = results ? results.filter(item => item.isCorrect).length : 
      Math.floor(Math.random() * dictationData.words.length); // 示例数据
    
    // 如果没有传递结果，生成示例结果
    const finalResults = results || dictationData.words.map(word => ({
      ...word,
      isCorrect: Math.random() > 0.2, // 80%的概率正确
      userAnswer: Math.random() > 0.2 ? word.word : word.word.slice(0, -1) + 'x' // 错误时修改最后一个字母
    }));
    
    setDictationData(prev => ({
      ...prev,
      results: finalResults,
      correctCount
    }));
    
    setMode('check');
  };
  
  // 处理重新开始听写
  const handleRetryDictation = () => {
    setMode('dictation');
    // 重置结果
    setDictationData(prev => ({
      ...prev,
      results: [],
      correctCount: 0
    }));
  };
  
  // 将全局设置与自定义设置合并
  const dictationSettings = getDictationSettings(dictationData.customSettings);
  
  return (
    <div className={`text-${settings.fontSize === '小' ? 'sm' : settings.fontSize === '中' ? 'base' : settings.fontSize === '大' ? 'lg' : 'xl'}`}>
      {mode === 'dictation' ? (
        <DictationPage 
          words={dictationData.words}
          bookInfo={dictationData.bookInfo}
          settings={dictationSettings}
          onComplete={handleDictationComplete}
        />
      ) : (
        <CheckResultPage 
          results={dictationData.results}
          bookInfo={dictationData.bookInfo}
          correctCount={dictationData.correctCount}
          totalCount={dictationData.totalCount}
          onRetry={handleRetryDictation}
        />
      )}
    </div>
  );
};

export default Dictation;